import { useState } from 'react';
import * as FileSaver from 'file-saver';
import { Button } from 'reactstrap';
import { toCsv } from '../../utils/csv';
import { useMultiProjectDashboardContext } from '../../contexts/MultiProjectDashboardContext';
import { UncontrolledWhiteTooltip } from '../basics/WhiteTooltip';
import { captureEvent } from '../../utils/analytics';

const EXPORT_PROJECTS_MAX = 50;

const ExportProjectsCsvButton = ({
  columns,
  exportType, // string to capture analytics for exports
  fetchData,
  filename,
  ...buttonProps
}) => {
  const {
    dashboards: { dashboardFarms },
  } = useMultiProjectDashboardContext();

  const [fetchingData, setFetchingData] = useState(false);

  const onClick = async () => {
    try {
      setFetchingData(true);
      const data = await fetchData();
      const csvData = toCsv(data, columns);
      const csv = new Blob([csvData], { type: 'text/csv' });
      FileSaver.saveAs(csv, filename);
    } catch (err) {
      console.error(err);
    } finally {
      setFetchingData(false);
      captureEvent('dashboard-data-exported', {
        projectCount: dashboardFarms.length,
        exportType,
      });
    }
  };

  // This button shouldn't be rendered if there are 0 farms
  // but disable export when there are just in case
  // Always disable when more than the maximum farms or when fetching data
  const projectsMaxExceeded = dashboardFarms.length > EXPORT_PROJECTS_MAX;
  const disabled =
    dashboardFarms.length === 0 || projectsMaxExceeded || fetchingData;

  return (
    <>
      <Button
        onClick={onClick}
        disabled={disabled}
        className="w-100"
        size="sm"
        outline
        color="secondary"
        id="export-farms-button"
        {...buttonProps}
      >
        {fetchingData ? 'Exporting...' : 'Export Selected Farms'}
      </Button>
      {projectsMaxExceeded && (
        <UncontrolledWhiteTooltip
          placement="top"
          target="export-farms-button"
          innerClassName="font-tiny"
        >
          Cannot export data for more than {EXPORT_PROJECTS_MAX} farms
        </UncontrolledWhiteTooltip>
      )}
    </>
  );
};

export default ExportProjectsCsvButton;
